import { FaqPage, FaqPage as HygraphFaqPage, Maybe } from '@/lib/types';

import { FaqPageCard } from '@/features/faq-page/type';
import hygraphImageTransformer from '@/hygraph/transformers/hygraph-image.transformer';

export default function faqPageCardTransformer({
  id,
  title,
  slug,
  cardImage,
  parent,
}: HygraphFaqPage): FaqPageCard {
  let fullUrl = '';

  let currentAncestor: Maybe<FaqPage> | undefined = parent;
  while (currentAncestor) {
    fullUrl = currentAncestor.slug + '/' + fullUrl;
    currentAncestor = currentAncestor.parent;
  }

  fullUrl = '/' + fullUrl + slug;

  return {
    id,
    title: title || '',
    slug: slug || '',
    fullUrl,
    cardImage: hygraphImageTransformer(cardImage) || null,
  };
}
